module.exports = __webpack_public_path__ + "img/dir_closed.4e43ffc3.png";